import * as yup from 'yup';
import docs from './attachments/specific';
import {
  parentesco,
  medicos,
  consentimentoDadosSensiveis,
  cpfResponsavelLegal,
  nomeDoTutor,
  adiantamentoQuinzenal,
  acessoContraCheque,
  // acessoJornalForluz,
  consentimentoDescontoFolha,
  aceiteInss,
  declaracaoVeracidade,
  consentimentoAcertoFinanceiro,
} from './utils/rulesByKey';

export const rcmaSchema = yup.object({
  ...parentesco,
  ...nomeDoTutor,
  ...medicos('medicoPerito'),
  ...medicos('medicoAssistente'),
  ...adiantamentoQuinzenal,
  ...acessoContraCheque,
  // ...acessoJornalForluz,
  ...consentimentoDadosSensiveis(),
  ...consentimentoDescontoFolha,
  ...declaracaoVeracidade,
  ...consentimentoAcertoFinanceiro,
  ...cpfResponsavelLegal,
  ...aceiteInss,
  ...docs.RCMADocs.rules,
});

export const rcmaInitialValues = {
  parentesco: '',
  nomeDoTutor: '',
  medicoPerito: '',
  medicoAssistente: '',
  adiantamentoQuinzenal: '',
  acessoContraCheque: '',
  // acessoJornalForluz: '',
  consentimentoDadosSensiveis: false,
  consentimentoDescontoFolha: false,
  declaracaoVeracidade: false,
  consentimentoAcertoFinanceiro: false,
  aceiteInss: false,
  cpfResponsavelLegal: '',
  ...docs.RCMADocs.initialValues,
};

export const rcmaDocs = {
  ...docs.RCMADocs.docs,
};
